import { keyframes } from './stitches.config'

export const opacityIn = keyframes({
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
  },
})

export const animationOpacityIn = `${opacityIn} .3s ease-in`
